const productCardLocales = {
  currency: {
    ar: "ج.م",
    en: "EGP",
  },
  addToCart: {
    ar: "أضف إلى السلة",
    en: "Add to cart",
  },
  inCart: {
    ar: "في السلة",
    en: "in cart",
  },
};

export default productCardLocales;
